import type { LinkedIssue } from '../stores/types';

/** Display name from `userId|Name` pending-with payloads. */
export function pendingWithDisplayName(pendingWith: string): string {
  const trimmed = pendingWith.trim();
  if (!trimmed) return '—';
  const pipe = trimmed.lastIndexOf('|');
  if (pipe >= 0 && pipe < trimmed.length - 1) {
    return trimmed.slice(pipe + 1).trim() || trimmed;
  }
  return trimmed;
}

/** Closed / done issues — matches Gantt task-details filter. */
export function isClosedIssue(issue: LinkedIssue): boolean {
  const category = issue.statusCategory.trim().toLowerCase();
  if (category === 'done' || category === 'closed') return true;
  const status = issue.status.trim().toLowerCase();
  return status === 'close' || status === 'closed' || status === 'done';
}

export function isCriticalPriority(priority: string | undefined | null): boolean {
  return String(priority ?? '')
    .trim()
    .toLowerCase() === 'critical';
}

export function isOpenCriticalIssue(issue: LinkedIssue): boolean {
  return !isClosedIssue(issue) && isCriticalPriority(issue.priority);
}
